import { render, staticRenderFns } from "./DepositReturnRule.vue?vue&type=template&id=2df01369&scoped=true"
import script from "./DepositReturnRule.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositReturnRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepositReturnRule.vue?vue&type=style&index=0&id=2df01369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df01369",
  null
  
)

export default component.exports